<template>
  <div class="create-whats-new__wrapper">
    <div class="create-whats-new__form row">
      <mi-select
        v-model="selectedOutputType"
        label="Output Type"
        :options="outputTypesList"
        :display-value="selectedOutputType.name"
        class="q-mb-sm mi-select-margin"
        options-selected-class="text-accent"
        outlined
        option-label="name"
        option-value="key"
      >
      </mi-select>
    </div>
    <create-whats-new-side-bar v-if="selectedOutputType.key === sideBarKey"></create-whats-new-side-bar>
    <create-whats-new-modal v-else></create-whats-new-modal>
  </div>
</template>

<script>
  import { ref } from 'vue'
  import CreateWhatsNewSideBar from './CreateWhatsNewSideBar.vue'
  import CreateWhatsNewModal from './CreateWhatsNewModal.vue'

  export default {
    name: 'CreateWhatsNew',
    components: { CreateWhatsNewModal, CreateWhatsNewSideBar },
    setup() {
      const outputTypesList = ref(
        [{ key: 'SIDE_BAR', name: 'Side bar' }, { key: 'MODAL', name: 'Modal' }]
      )
      const selectedOutputType = ref(outputTypesList.value[1])
      const sideBarKey = ref('SIDE_BAR')

      return {
        selectedOutputType,
        outputTypesList,
        sideBarKey
      }
    }

  }
</script>

<style lang="scss" scoped>
  .create-whats-new {
    &__wrapper {
      padding: 8px 16px;
      color: $mi-anthracite-800;
      font-family: $mi-typography-font-family-condensed;
    }

    &__form {
      .q-field:nth-child(1) {
        width: 45%;
      }

      .q-field:nth-child(2) {
        width: 85%;
      }

      .mi-select-margin {
        margin-bottom: 32px;
      }
    }
  }
</style>
